<template lang="html">
  <div class="col-md-12 col-sm-12 col-xs-12">
    <!-- {{powerState}} -->
    <!-- {{inverterId}} -->
    <el-alert
      show-icon
      v-show="subExpiry"
      title="Subscription expiry date"
      type="success"
      :closable="false"
    >
      <h3>
        {{ subExpiry }}
        <button
          style="float: right"
          @click="getDeviceState"
          class="btn btn-primary"
        >
          Refresh
        </button>
      </h3>
    </el-alert>
    <div style="width: 100%; flex-flow: row; display: flex">
      <div class="top-widget-box performance">
        <div class="top-widget-box__body">
          <div class="col-md-3 col-sm-6" v-if="powerState == `OFF`">
            <div
              class="widget widget-alpha widget-alpha--color-amaranth"
              @click="showControl('power', '11')"
            >
              <i class="fa fa-power-off fa-2x" style="color: #2980b9"></i>
              Power On
            </div>
          </div>

          <div class="col-md-3 col-sm-6" v-if="powerState == `ON`">
            <div
              class="widget widget-alpha widget-alpha--color-amaranth"
              @click="showControl('power', '00')"
            >
              <i class="fa fa-power-off fa-2x" style="color: #e74c3c"></i>
              <span class="sm-font-size">Power Off</span>
            </div>
          </div>
          <can I="read" a="all">
            <div class="col-md-3 col-sm-6 d-none">
              <div
                class="widget widget-alpha widget-alpha--color-amaranth"
                @click="showControl('expiry', 'set')"
              >
                <i class="fa fa-calendar fa-2x" style="color: #2c3e50"></i>
                <span class="sm-font-size">Set Expiry Date</span>
              </div>
            </div>
            <div class="col-md-3 col-sm-6" v-if="adminPower == `OFF`">
              <div
                class="widget widget-alpha widget-alpha--color-amaranth d-none"
                @click="showControl('admin', '11')"
              >
                <i
                  class="fa fa-check-square-o fa-2x"
                  style="color: #16a085"
                ></i>
                <span class="sm-font-size">Admin Enable Device</span>
              </div>
            </div>

            <div class="col-md-3 col-sm-6" v-if="adminPower == `ON`">
              <div
                class="widget widget-alpha widget-alpha--color-amaranth d-none"
                @click="showControl('admin', '00')"
              >
                <i class="fa fa-ban fa-2x" style="color: #95a5a6"></i>
                <span class="sm-font-size">Admin Disable Device</span>
              </div>
            </div>

            <div class="col-md-3 col-sm-6 display-none">
              <div
                class="widget widget-alpha widget-alpha--color-amaranth"
                @click="showControl('charger-priority', 'pcp')"
              >
                <i class="fa fa-plug fa-2x" style="color: rgb(232, 150, 0)"></i>
                <span class="sm-font-size">Set Charger Priority</span>
              </div>
            </div>

            <div class="col-md-3 col-sm-6 display-none">
              <div
                class="widget widget-alpha widget-alpha--color-amaranth"
                @click="showControl('output-priority', 'pop')"
              >
                <i class="fa fa-cogs fa-2x" style="color: rgb(232, 150, 0)"></i>
                <span class="sm-font-size">Set Output Priority</span>
              </div>
            </div>

            <div class="col-md-3 col-sm-6 display-none">
              <div
                class="widget widget-alpha widget-alpha--color-amaranth"
                @click="showControl('device-mode', 'pgr')"
              >
                <i
                  class="fa fa-server fa-2x"
                  style="color: rgb(232, 15, 90)"
                ></i>
                <span class="sm-font-size">Set Device Mode</span>
              </div>
            </div>
          </can>
        </div>
      </div>
    </div>

    <div
      style="width: 100%; flex-flow: column; display: flex"
      v-if="deviceShadow && deviceShadow.delta"
    >
      <h3>Pending Changes</h3>
      <ul>
        <li
          v-for="singleKey in Object.keys(deviceShadow.delta)"
          :key="`desired_${singleKey}`"
        >
          <b>{{ singleKey }} : </b> {{ deviceShadow.delta[singleKey] }}
        </li>
      </ul>
    </div>
    <!-- <b-modal
      centered
      id="controlModal"
      hide-footer
      no-close-on-backdrop
      ref="controlModal"
    > -->
    <transition css="false">
      <el-dialog
        title="Device Control"
        :visible.sync="controlModal"
        :close-on-click-modal="false"
        width="30%"
      >
        <!-- <div slot="title">Device Control</div> -->
        <div>
          <div v-if="currentCommand === 'power'">
            Are you sure you want to switch Device power
            {{ currentParam == "11" ? "On" : "Off" }}?
          </div>
          <div v-else-if="currentCommand === 'expiry'">
            <div v-if="currentParam === 'get'">Get Expiry Date?</div>
            <div v-else-if="currentParam === 'set'">
              <datetime
                v-model="expiryDate_"
                class="form-control form-control-lg"
                placeholder="Pick a date"
                type="datetime"
                input-class="form-control form-control-lg"
              ></datetime>
            </div>
          </div>
          <div v-else-if="currentCommand === 'charger-priority'">
            <div>
              <div style="text-align: centea">Set Chargerr Priority</div>
              <hr />

              <b-form-select
                v-model="chargerPriority"
                :options="chargerPriorityList"
                class="mb-3"
              />
            </div>
          </div>
          <div v-else-if="currentCommand === 'output-priority'">
            <div>
              <div style="text-align: centea">Set Output Priority</div>
              <hr />
              <b-form-select
                v-model="outputPriority"
                :options="outputPriorityList"
                class="mb-3"
              />
            </div>
          </div>
          <div v-else-if="currentCommand === 'device-mode'">
            <div>
              <div style="text-align: center">Set Device Mode</div>
              <hr />
              <b-form-select
                v-model="deviceMode"
                :options="deviceModeList"
                class="mb-3"
              />
            </div>
          </div>
          <div v-else-if="currentCommand === 'command'">
            <div>
              Send Command:
              <hr />
              <fieldset>
                <div class="form-group">
                  <div class="input-group">
                    <input
                      id="simple-input"
                      v-model="commandSending"
                      required
                    />
                    <label class="control-label" for="simple-input"
                      >Command to send</label
                    >
                    <i class="bar"></i>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div v-else-if="currentCommand === 'shell'">
            <div>
              Send Command:
              <hr />
              <fieldset>
                <div class="form-group">
                  <div class="input-group">
                    <input
                      id="simple-input"
                      v-model="commandSending"
                      required
                    />
                    <label class="control-label" for="simple-input"
                      >Command to send</label
                    >
                    <i class="bar"></i>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div v-else-if="currentCommand === 'reboot'">
            <div>Reboot Inverter?</div>
          </div>
          <div v-else-if="currentCommand === 'settings'">
            <div>Request Inverter Settings?</div>
          </div>
          <div v-else-if="currentCommand === 'reset'">
            <div>Reset Board?</div>
          </div>
          <div v-else-if="currentCommand === 'batteql'">
            <div>Request Battery Equalization?</div>
          </div>
          <div v-else-if="currentCommand === 'admin'">
            <div v-if="currentParam === '11'">
              Sure you want to activate device?
            </div>
            <div v-else-if="currentParam === '00'">
              Sure you want to disable device?
            </div>
          </div>
          <div v-else-if="currentCommand === 'ssh'">
            Open SSH Access:
            <hr style />
            <fieldset>
              <div class="form-group">
                <div class="input-group">
                  <input id="simple-input" v-model="ipAddress" required />
                  <label class="control-label" for="simple-input"
                    >IP Address</label
                  >
                  <i class="bar"></i>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <input id="simple-input" v-model="username" required />
                  <label class="control-label" for="simple-input"
                    >Username</label
                  >
                  <i class="bar"></i>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <input id="simple-input" v-model="password" required />
                  <label class="control-label" for="simple-input"
                    >Password</label
                  >
                  <i class="bar"></i>
                </div>
              </div>
            </fieldset>
          </div>
          <hr />
          <div style="text-align: center">
            <button
              class="btn btn-primary btn-with-icon rounded-icon btn-micro"
              style="margin-right: 12px"
              @click="control()"
            >
              <i class="fa-check fa"></i>
            </button>
            <button
              class="btn btn-danger btn-with-icon rounded-icon btn-micro"
              @click="hideControl()"
              style="margin-right: 12px"
            >
              <i class="fa-close fa"></i>
            </button>
          </div>
        </div>
      </el-dialog>
    </transition>
  </div>
</template>
<script>
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Datetime } from "vue-datetime";
import { HTTP as IOTHTTP } from "../../../../store/actions";
import Vue from "vue";
import { Alert } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(Alert);
export default {
  name: "device-control",
  components: {
    datetime: Datetime
  },
  data: function() {
    return {
      endpointsMap: {
        "11-power": "power",

        "00-power": "power",

        "get-expiry": "requestexpdate",

        "set-expiry": "expirydate",

        "pcp-charger-priority": "charger-priority",

        "pop-output-priority": "output-priority",

        "pgr-device-mode": "device-mode",

        "open-ssh": "ssh",

        "command-shell": "shell",

        "send-command": "command",

        "init-reboot": "reboot",

        "get-settings": "setting",

        "init-reset": "reset",

        "get-batteql": "battequal",

        "11-admin": "admin",

        "00-admin": "admin"
      },
      powerMap: {
        11: "ON",
        "00": "OFF"
      },
      chargerPriority: "01",
      chargerPriorityList: [
        {
          text: "Select Option",
          value: null,
          disabled: true
        },
        {
          text: "Utility First",
          value: "00"
        },
        {
          text: "Solar First",
          value: "01"
        },
        {
          text: "Solar and Utility",
          value: "02"
        }
      ],
      outputPriority: "01",
      outputPriorityList: [
        {
          text: "Select Option",
          value: null,
          disabled: true
        },
        {
          text: "Utility First",
          value: "00"
        },
        {
          text: "Solar First",
          value: "01"
        },
        {
          text: "SBU First",
          value: "02"
        }
      ],
      deviceMode: "00",
      deviceModeList: [
        {
          text: "Select Option",
          value: null,
          disabled: true
        },
        {
          text: "Inverter Mode",
          value: "00"
        },
        {
          text: "UPS Mode",
          value: "01"
        }
      ],
      subExpiry: null,
      showWarning: false,
      powerState: null,
      adminPower: null,
      currentCommand: "",
      controlModal: false,
      deviceShadow: {}
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  props: {
    inverterId: {
      default: null
    },
    identifier: {
      default: "EMS"
    },
    inverterNum: {
      default: ""
    }
  },
  methods: {
    getDeviceState() {
      console.log("Getting Device State");
      let container = this;
      var inverterId = this.inverterId;
      if (this.identifier == "LUX") {
        const LuxHTTP = this.$httpUtils.LUXHTTP;
        const url = `/inverters/system_state?serialNumber=${this.inverterNum}`;
        LuxHTTP.get(url)
          .then(response => {
            if (response.data == true) {
              container.powerState = "ON";
              container.adminPower = "ON";
            }
            if (response.data == false) {
              container.powerState = "OFF";
              container.adminPower = "OFF";
            }
          })
          .catch(err => {
            this.showErrorMsg({ message: "Error occured at our end!" });
          });
      } else {
        var FASTHTTP = this.$httpUtils.FastAPIHTTP;
        FASTHTTP.get(`/devicestate/${inverterId}?${Date.now()}`)
          .then(resp => {
            container.deviceShadow = resp.data.state;

            if (resp.data.state.reported.userPower) {
              container.powerState =
                container.powerMap[resp.data.state.reported.userPower];
            }
            if (resp.data.state.reported.adminPower) {
              container.adminPower =
                container.powerMap[resp.data.state.reported.adminPower];
            }
            if (resp.data.state.reported.setExpiry) {
              container.subExpiry = new Date(
                resp.data.state.reported.setExpiry
              ).toString();
            }
          })
          .catch(err => {
            //console.log(err)
          });
      }
    },
    showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.controlModal = true;
      //   this.$refs.controlModal.show();
    },
    hideControl() {
      //   this.$refs.controlModal.hide();
      this.controlModal = false;
    },
    control() {
      const HTTP = this.$httpUtils.instance;
      var inverterId = `${this.inverterId}`;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      console.log(param + "-" + command + " => " + inverterId);
      var path = this.endpointsMap[key];
      var requestLink = `${this.$utilConstants.IOT_BASE_URL}/event/publish/`;
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = JSON.stringify({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = JSON.stringify({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = JSON.stringify({
            command: `${param.toUpperCase()}${this.chargerPriority}`
          });
          break;
        case "output-priority":
          requestParam.payload = JSON.stringify({
            command: `${param.toUpperCase()}${this.outputPriority}`
          });
          break;
        case "device-mode":
          requestParam.payload = JSON.stringify({
            command: `${param.toUpperCase()}${this.deviceMode}`
          });
          break;
        case "ssh":
          requestParam =
            "ipaddress=" +
            this.ipAddress +
            "&username=" +
            this.username +
            "&password=" +
            this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = JSON.stringify({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      switch (this.identifier) {
        case "LUX":
          const LuxHTTP = this.$httpUtils.LUXHTTP;
          let url_turn_off = `/inverters/turn_off/${this.inverterNum}`;
          let url_turn_on = `/inverters/turn_on/${this.inverterNum}`;

          if (this.powerState == "ON") {
            LuxHTTP.post(url_turn_off, this.inverterNum)
              .then(res => {
                this.showSuccessMsg({ message: "System turned off" });
                this.hideControl();
              })
              .catch(error => {
                this.showErrorMsg({ message: "Failed to turn system Off" });
              });
          } else if (this.powerState == "OFF") {
            LuxHTTP.post(url_turn_on, this.inverterNum)
              .then(res => {
                this.showSuccessMsg({ message: "System turned On" });
                this.hideControl();
              })
              .catch(error => {
                this.showErrorMsg({ message: "Failed to turn system On" });
              });
          } else {
            console.log("Error with LUX endpoint");
          }
          break;
        case "EMS":
          HTTP.post(requestLink, requestParam)
            .then(response => {
              alert("Sent!!!");
              this.hideControl();
              this.getDeviceState();
            })
            .catch(e => {
              console.log(e);
            });
          break;
        default:
          this.showErrorMsg({ message: "System cannot be identified" });
      }
    }
  },
  mounted() {
    this.getDeviceState();
  }
};
</script>
<style lang="scss">
.el-alert__content {
  width: 100% !important;
}
.display-none {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/widgets/controls.vue